import { ExpandMoreRounded } from '@mui/icons-material'
import { Card, CardContent, Box, Typography, IconButton, Collapse, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { getSoftChipSx } from './chipStyles'
import { theme } from '../theme'

interface Props {
  defaultExpanded?: boolean
  children: React.ReactNode
  title: string
  statusLabel?: string
  statusColor?: string
}

export const CollapsableCard: React.FC<Props> = ({
  children,
  title,
  defaultExpanded = false,
  statusLabel,
  statusColor,
}) => {
  const isMobile = useMediaQuery('(max-width:600px)')
  const [expanded, setExpanded] = useState(defaultExpanded)

  const handleToggleExpand = () => {
    setExpanded(!expanded)
  }
  return (
    <Card
      sx={{
        m: 0,
        width: '100%',
        borderRadius: 4,
      }}
    >
      <CardContent
        sx={{
          m: 0,
          p: { xs: '6px 12px !important', sm: '12px !important' },
          '&:last-child': { pb: { xs: '6px', sm: '12px' } },
        }}
      >
        <Box
          onClick={handleToggleExpand}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: isMobile ? 34 : 44,
            cursor: 'pointer',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography variant="subtitle1" component="p" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {title}
            </Typography>
            {statusLabel && statusColor && (
              <Box
                component="span"
                sx={getSoftChipSx(statusColor, {
                  height: 28,
                  fontSize: 12,
                  labelWeight: 600,
                  emphasis: true,
                  maxWidth: 'none',
                })}
              >
                <Typography
                  sx={{
                    px: 1.25,
                    fontSize: 12,
                    fontWeight: 600,
                    lineHeight: '28px',
                    whiteSpace: 'nowrap',
                    color: '#203864',
                  }}
                >
                  {statusLabel}
                </Typography>
              </Box>
            )}
          </Box>
          <IconButton size="small" sx={{ color: '#7A8197' }}>
            <ExpandMoreRounded
              style={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: theme.transitions.create('transform', {
                  duration: theme.transitions.duration.shortest,
                }),
                fontSize: isMobile ? 28 : 26,
              }}
            />
          </IconButton>
        </Box>
        <Collapse in={expanded} timeout="auto" sx={{ pt: expanded ? 0.5 : 0 }}>
          {children}
        </Collapse>
      </CardContent>
    </Card>
  )
}
